module.exports = __webpack_public_path__ + "static/img/awayGoal.32db4da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/awayGoal.png
// module id = jXQR
// module chunks = 94